import { Box, Typography, type SxProps, type Theme } from '@mui/material';

export const APP_NAME = 'PackPilot';
export const APP_TAGLINE = 'Run your business. Stay in control.';

/** The product wordmark: "PackPilot" over a small "BY PACKBYTES". `onDark` for the hero panel. */
export function Wordmark({
  size = 'md',
  onDark = false,
  sx,
}: {
  size?: 'md' | 'lg';
  onDark?: boolean;
  sx?: SxProps<Theme>;
}) {
  return (
    <Box sx={sx}>
      <Typography
        variant={size === 'lg' ? 'h5' : 'h6'}
        component="div"
        sx={{ lineHeight: 1.1, color: onDark ? '#fff' : 'text.primary' }}
      >
        {APP_NAME}
      </Typography>
      <Typography
        component="div"
        sx={{
          fontSize: size === 'lg' ? 10.5 : 9.5,
          fontWeight: 700,
          letterSpacing: '0.16em',
          lineHeight: 1.4,
          color: onDark ? 'rgba(255,255,255,0.7)' : 'text.secondary',
        }}
      >
        BY PACKBYTES
      </Typography>
    </Box>
  );
}
